import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Picture from './Components/Picture';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Galerie from './Components/Galerie';
import Titlebar from './Components/Titlebar';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>    
    <div>
  <BrowserRouter>
  <Routes>
    <Route exact  path="/images/:picture" element={<Picture/>} >
    </Route>
    <Route path="/galerie" element={<div><Titlebar/><Galerie/></div>}></Route>
  </Routes>
  </BrowserRouter>
</div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
